<template>
  <AppLayout>
    <v-container grid-list-md fluid pa-0 class="houses">
      <v-layout justify-center row wrap>
        <v-slide-x-reverse-transition>
          <v-flex class="md8 lg6 houses__list">
            <v-toolbar color="white elevation-1" height="72">
              <v-text-field
                v-model="searchTerm"
                placeholder="Search house..."
                prepend-icon="search"
                hide-details
                single-line
              ></v-text-field>
              <v-spacer />
              <AddHouse />
              <v-menu>
                <template #activator="{ on: menu }">
                  <v-tooltip top>
                    <template #activator="{ on: tooltip }">
                      <v-btn
                        flat
                        icon
                        color="primary"
                        v-on="{ ...tooltip, ...menu }"
                      >
                        <v-icon color="primary" dark>sort</v-icon>
                      </v-btn>
                    </template>
                    <span>Sort house list</span>
                  </v-tooltip>
                </template>
                <v-list>
                  <v-list-tile @click="selectedSorting = 'id'">
                    <v-list-tile-title>House ID</v-list-tile-title>
                  </v-list-tile>
                  <v-list-tile @click="selectedSorting = 'streetName'">
                    <v-list-tile-title>Street Name</v-list-tile-title>
                  </v-list-tile>
                  <v-list-tile @click="selectedSorting = 'streetNumber'">
                    <v-list-tile-title>Street Number</v-list-tile-title>
                  </v-list-tile>
                  <v-list-tile @click="selectedSorting = 'suburb'">
                    <v-list-tile-title>Suburb</v-list-tile-title>
                  </v-list-tile>
                  <v-list-tile @click="selectedSorting = 'leaseCheckoutDate'">
                    <v-list-tile-title>Lease Checkout Date</v-list-tile-title>
                  </v-list-tile>
                </v-list>
              </v-menu>
              <v-menu>
                <template #activator="{ on: menu }">
                  <v-tooltip top>
                    <template #activator="{ on: tooltip }">
                      <v-btn
                        flat
                        icon
                        color="primary"
                        v-on="{ ...tooltip, ...menu }"
                      >
                        <v-icon color="primary" dark>filter</v-icon>
                      </v-btn>
                    </template>
                    <span>Filters</span>
                  </v-tooltip>
                </template>
                <v-list>
                  <v-list-tile @click="selectedFilter = 'all'">
                    <v-list-tile-title>All</v-list-tile-title>
                  </v-list-tile>
                  <v-list-tile @click="selectedFilter = 'onlyme'">
                    <v-list-tile-title>Only Me</v-list-tile-title>
                  </v-list-tile>
                  <v-list-tile @click="selectedFilter = 'orphan'">
                    <v-list-tile-title>With no manager</v-list-tile-title>
                  </v-list-tile>
                  <v-divider></v-divider>
                  <v-list-tile>
                    <v-list-tile-title>Inactive fees only</v-list-tile-title>
                    <v-list-tile-content>
                      <v-checkbox v-model="withInactiveFeesOnly"></v-checkbox>
                    </v-list-tile-content>
                  </v-list-tile>
                  <v-divider></v-divider>
                  <v-list-tile>
                    <v-list-tile-title>Show leasing only</v-list-tile-title>
                    <v-list-tile-content>
                      <v-checkbox v-model="showLeasingOnly"></v-checkbox>
                    </v-list-tile-content>
                  </v-list-tile>
                  <v-list-tile>
                    <v-list-tile-title>Including archived houses</v-list-tile-title>
                    <v-list-tile-content>
                      <v-checkbox v-model="includingArchived"></v-checkbox>
                    </v-list-tile-content>
                  </v-list-tile>
                </v-list>
              </v-menu>
            </v-toolbar>
            <v-card>
              <v-list v-if="filteredHouses && filteredHouses.length > 0" two-line subheader>
                <template v-for="house in filteredHouses">
                  <v-list-tile
                    :key="house.id"
                    @click="displaySelectedHouse(house.id)"
                  >
                    <v-list-tile-avatar>
                      <v-chip style="color: darkred">{{house.id}}</v-chip>
                    </v-list-tile-avatar>
                    <v-list-tile-avatar  v-if="$vuetify.breakpoint.smAndUp">
                      <v-icon color="primary">home</v-icon>
                    </v-list-tile-avatar>
                    <v-list-tile-content>
                      <span style="font-weight: bold; white-space:nowrap;">{{house.note}}</span>
                      <v-list-tile-title>
                        {{showAddress(house.unit, house.num, house.street)}}
                      </v-list-tile-title>
                      <v-list-tile-sub-title>{{
                        house.suburb + ', ' + house.city
                      }}</v-list-tile-sub-title>
                    </v-list-tile-content>
                    <v-list-tile-action>
                      <div style="display:flex" id="chips-container">
                        <v-chip v-if="selectedSorting === 'leaseCheckoutDate'" small :class="leaseCheckoutStatus(house)">
                         {{ house.leaseCheckoutDate }}
                        </v-chip>
                        <!-- <v-icon>info</v-icon> -->
                        <span class="manager" v-if="house.pm" :style="{ 'background-color': house.pm.icon_color }" >{{house.pm.account}}</span>
                      </div>
                    </v-list-tile-action>
                  </v-list-tile>
                </template>
              </v-list>
              <v-card-text v-else class="text-xs-center subheading">
                <p v-if="filteredHouses && filteredHouses.length === 0 && searchTerm !== null">
                  Sorry, we couldnt find any matching houses
                </p>
                <p v-else>Use the "Add" button to add a new house</p>
              </v-card-text>
              <v-card-actions>
                <v-spacer />
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-slide-x-reverse-transition>
      </v-layout>
    </v-container>
  </AppLayout>
</template>

<script>
import AppLayout from '@/views/AppLayout'
import AddHouse from '@/components/houselist/Add'
import authHelper from '@/helpers/auth'
import { mapGetters, mapActions } from 'vuex'
import moment from 'moment'

export default {
  name: 'HouseList',
  components: {
    AppLayout,
    AddHouse,
  },
  data() {
    return {
      searchTerm: null,
      selectedSorting: null,
      selectedFilter: null,
      showLeasingOnly: false,
      includingArchived: false,
      withInactiveFeesOnly: false,
    }
  },
  computed: {
    ...mapGetters({
      houses: 'HouseList/getHouseList',
      selectedHouse: 'HouseList/getSelectedHouse',
    }),
    houseSelected: function() {
      return Object.keys(this.selectedHouse).length > 0
    },
    user() {
      return authHelper.getUser();
    },
    /**
     * This computed is what used by the view
     * This will filter and sort houses data based on selected options
     */
    filteredHouses() {
      const clonedHouses = JSON.parse(JSON.stringify(this.houses))
      let filteredHouses = this._filterHouses(clonedHouses)
      return this._sortBy(filteredHouses, this.selectedSorting)
    },
  },
  mounted() {
    this.getHouseList()
  },
  methods: {
    ...mapActions({
      getHouseList: 'HouseList/list',
      fetchHouse: 'HouseList/fetchHouse',
      clear: 'HouseList/clearStorage',
    }),
    leaseCheckoutStatus(house) {
      const now = moment();
      const leaseCheckoutDate = moment(house.leaseCheckoutDate, 'YYYY-MM-DD');
      const days = leaseCheckoutDate.diff(now, 'days')
      if (days < 7) {
        return 'checking-out'
      } else if (days < 30) {
        return 'confirming-rerent'
      } else if (days < 61) {
        return 'reminding-rerent'
      }
    },
    displaySelectedHouse(id) {
      this.clear()
      this.$router.push({
        name: 'houseDetailInfo',
        params: { houseId: id }
      })
      // this.fetchHouse(house.house_id)
    },
    /**
     * This function will filter and sort the data based on the passed options
     */
    /**
     * This function will filter the houses based on the filter
     * Creates an array of the fields that we want to search and
     * then converts that to a string and returns the ones that
     * matches the filter
     */
    _filterHouses(houses) {
      const filter = this.searchTerm
      const type = this.selectedFilter
      const showLeasingOnly = this.showLeasingOnly
      const includingArchived = this.includingArchived
      const withInactiveFeesOnly = this.withInactiveFeesOnly

      let afterFilter = [];
      if (filter) {
        // Regex, we want everything that matches the term
        const reg = new RegExp(filter.toLowerCase().replace(/\s+/g, '\\s+'))
        afterFilter = houses.filter((house) => {
          // Create an array with values that we want to search
          const matcher = [
            house.unit + '/' + house.num,
            house.street,
            house.suburb,
            house.city,
            house.country,
          ]

          // Convert the array to string and find the matches
          return reg.test(matcher.join(' ').toLowerCase()) || filter == house.id
        });
      } else {
        // No searchTerm. Return all houses
        afterFilter = houses
      }
      if (!includingArchived) {
        afterFilter = afterFilter.filter(h => !h.archived)
      }
      if (withInactiveFeesOnly) {
        afterFilter = afterFilter.filter(h => h.fee.find(f => f.state === 99) != null)
      }

      const curDate = new Date();
      if (showLeasingOnly) {
        afterFilter = afterFilter.filter(h => !!h.lease.find(lease => new Date(lease.checkout_date) >= curDate))
      }

      let returned = [];
      if (type === 'onlyme') {
        const accountId = Number(this.user.accountId)
        returned = afterFilter.filter(h => h.pm_id == accountId)
      } else if (type === 'orphan') {
        returned = afterFilter.filter(h => !h.pm_id)
      } else if (type === 'all' || !type) {
        returned = afterFilter
      }
      return returned;
    },
    _sortBy(houses, type) {
      if (!type) {
        type = 'streetNumber'
      }

      if (type === 'id') {
        return houses.sort((a, b) => {
          return a.id - b.id
        })
      } else if (type === 'streetName') {
        return houses.sort((a, b) => {
          return a.street.localeCompare(b.street)
        })
      } else if (type === 'streetNumber') {
        return houses.sort((a, b) => {
          const na = parseInt(a.num, 10)
          const nb = parseInt(b.num, 10)
          if (Number.isNaN(na) && Number.isNaN(nb)) {
             return a.num - b.num;
          } else if (Number.isNaN(na)) {
            return 1;
          } else if (Number.isNaN(nb)) {
            return -1;
          } else {
             return na - nb
          }
        })
      } else if (type === 'suburb') {
        return houses.sort((a, b) => {
          return a.suburb.localeCompare(b.suburb)
        })
      } else if (type === 'leaseCheckoutDate') {
        return houses.sort((a, b) => {
          if (!a.leaseCheckoutDate) {
            return 1;
          }
          if (!b.leaseCheckoutDate) {
            return -1;
          }
          return a.leaseCheckoutDate.localeCompare(b.leaseCheckoutDate)
        })
      }
    },
    showAddress: function(unit, number, street) {
      let address = ''

      if (unit) {
        address += unit + '/'
      }

      if (number) {
        address += number + ' '
      }

      if (street) {
        address += street
      }

      return address
    },
    isInViewport: function(elem) {
      const distance = elem.getBoundingClientRect()

      return (
        distance.top >= 0 &&
        distance.left >= 0 &&
        distance.bottom <=
          (window.innerHeight || document.documentElement.clientHeight) &&
        distance.right <=
          (window.innerWidth || document.documentElement.clientWidth)
      )
    },
  },
}
</script>

<style lang="stylus" scoped>
  @import '~vuetify/src/stylus/settings/_colors';

  .manager {
    color: var(--v-accent-lighten2)

    border-radius: 50%;
    width:55px;
    padding: 2px 5px;
    /*
      background-color: navy;
      color: white;
    */
  }

  .v-list__tile--selected {
    border-left: 5px solid #2484C6;
    background-color: $grey.lighten-3;
  }

  .houses {
    position: relative;

    &__list .v-list {
      max-height: 80vh;
      overflow-y: scroll;

      > div {
        border-bottom: 1px solid $grey.lighten-2;
      }
    }

    &__list--selected {
      position: sticky;
      top: 80px;
      max-height: 690px;
      padding-right: 20px !important;

      .v-list {
        max-height: 600px;
      }
    }
  }

  .checking-out {
    background: orange;
  }
  .confirming-rerent {
    background: lightgreen;
  }
  .reminding-rerent {
    background: lightblue;
  }
</style>
